




































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class Login extends Vue {
  private email = null;
  private password = null;
  private loading = false;

  @State('error')
  private error!: any;

  public async login() {
    this.loading = true;
    try {
      await this.$store.dispatch('LOGIN', {
        username: this.email,
        password: this.password,
      });
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
}
